import React from "react";
import { Typography, Box, Grid, TextField, Button } from "@mui/material";
import { Link } from "react-router-dom";
const FAQ = () => {
  return (
    <>
      <Box
        sx={{
          paddingX: { lg: "113px", xs: "10px" },
          paddingY: "96px",
        }}
      >
        <Grid container>
          <Grid item lg={7} xs={12}>
            <Box>
              <Typography
                className=""
                variant="h1"
                color={"#5A589C"}
                sx={{
                  textAlign: { lg: "start", xs: "center" },
                  fontSize: { xs: "32px", lg: "34px" },
                  fontWeight: 700,
                }}
                noWrap
              >
                Sign up for our newsletter
              </Typography>
              <Typography
                className="FAQsubheading"
                color={"grey.main"}
                sx={{ textAlign: { lg: "start", xs: "center" } }}
              >
                Be the first to know about releases and industry news and
                insights.
              </Typography>
            </Box>
          </Grid>

          <Grid
            item
            lg={5}
            xs={12}
            sx={{ marginTop: { lg: "0px", xs: "60px" } }}
          >
            <Box
              display={"flex"}
              flexDirection={{ lg: "row", xs: "column" }}
              justifyContent={{ lg: "start", xs: "center" }}
              alignItems={{ lg: "start", xs: "center" }}
            >
              <Box>
                <TextField
                  variant="outlined"
                  label="Enter Your Email"
                  size="small"
                  sx={{
                    width: { lg: "350px", xs: "350px" },
                    backgroundColor: "white !important",
                    color: "white !important",
                    marginRight: { lg: "15px", xs: "0px" },
                    marginBottom: { lg: "0px", xs: "10px" },
                    borderRadius: "5px",
                  }}
                ></TextField>
              </Box>
              <Box
                display="flex"
                justifyContent={{
                  lg: "start",
                  xs: "center",
                }}
              >
                <Link to="/generate">
                  <Button
                    className={"GenerateNow"}
                    sx={{
                      fontStyle: "SemiBold",
                      fontSize: "16px",
                      color: "blue.main",
                      backgroundColor: "yellow.secondary",
                      borderRadius: "5px !important",
                      width: { lg: "118px", xs: "350px" },
                      "&:hover": {
                        color: "white.main",
                        backgroundColor: "blue.main",
                      },
                    }}
                  >
                    Subscribe
                  </Button>
                </Link>
              </Box>
            </Box>
            <Box
              display="flex"
              justifyContent={{
                lg: "start",
                xs: "center",
              }}
            >
              <Typography
                color={"grey.main"}
                sx={{
                  textAlign: { lg: "start", xs: "center" },
                  fontFamily: "Inter",
                  fontSize: "14px",
                  fontWeight: 400,
                  display: "flex",
                  marginTop: { lg: "4px", xs: "10px" },
                }}
              >
                We care about your data in our{" "}
                <Typography
                  variant="inherit"
                  sx={{ textDecoration: "underline", paddingLeft: "4px" }}
                >
                  {" "}
                  privacy policy
                </Typography>
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default FAQ;
